module.exports = __webpack_public_path__ + "img/client-7.8335c1d0.png";